var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "p-10" }, [
    _c("div", { staticClass: "p-20 bg-white" }, [
      _c("div", { staticClass: "pb-10 fs-a1" }, [
        _vm._v(_vm._s(_vm.info.title)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "fs-s3 text-gray" }, [
        _vm._v(_vm._s(_vm.parseTime(_vm.info.add_date))),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "max-w",
        domProps: { innerHTML: _vm._s(_vm.info.content) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }